import Index from "../../pages/tideng/ani-appoint/index";
import Pc from "../../pages/tideng/ani-appoint/pc";

const base = "ani-appoint";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/tideng/aniAppoint.js